/**
 * Simple logger utility that respects environment
 * 
 * In production: Only errors are logged
 * In development: All logs are shown
 */

const isDev = process.env.NODE_ENV !== 'production';

type LogCategory = 'websocket' | 'audio' | 'session' | 'analysis' | 'hints' | 'general';

const isEnabled = (_category: LogCategory): boolean => {
  return isDev;
};

export const logger = {
  debug: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },

  info: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.log(message, ...args);
    }
  },

  warn: (message: string, ...args: unknown[]): void => {
    if (isDev) {
      console.warn(message, ...args);
    }
  },

  error: (message: string, ...args: unknown[]): void => {
    console.error(message, ...args);
  },

  category: (cat: LogCategory, message: string, ...args: unknown[]): void => {
    if (isEnabled(cat)) {
      console.log(`[${cat.toUpperCase()}] ${message}`, ...args);
    }
  },
};

export const wsLog = (message: string, ...args: unknown[]) => 
  logger.category('websocket', message, ...args);

export const audioLog = (message: string, ...args: unknown[]) => 
  logger.category('audio', message, ...args);

export const sessionLog = (message: string, ...args: unknown[]) => 
  logger.category('session', message, ...args);

export default logger;
